import { render } from "./OrderNavbar.vue?vue&type=template&id=7a21451e&scoped=true"
import script from "./OrderNavbar.vue?vue&type=script&lang=js"
export * from "./OrderNavbar.vue?vue&type=script&lang=js"

import "./OrderNavbar.vue?vue&type=style&index=0&id=7a21451e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a21451e"]])

export default __exports__